import { render, staticRenderFns } from "./ventasVScobranzaVSxcobrar.vue?vue&type=template&id=25787509"
import script from "./ventasVScobranzaVSxcobrar.vue?vue&type=script&lang=js"
export * from "./ventasVScobranzaVSxcobrar.vue?vue&type=script&lang=js"
import style0 from "./ventasVScobranzaVSxcobrar.vue?vue&type=style&index=0&id=25787509&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports